import { DashboardIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/reports',
    component: () => import('@/pages/data/index.vue'),
    name: 'data',
    meta: {
      title: '销售日报',
      icon: shallowRef(DashboardIcon),
      orderNo: 1,
      single: true,
      permission: ['ReportsView'],
    },
  },
  {
    path: '/reports/:date',
    component: () => import('@/pages/data/index.vue'),
    name: 'dataWithDate',
    meta: {
      title: '数据统计',
      hidden: true, // 隐藏此路由，不在菜单中显示
    },
  },
] as RouteRecordRaw[];
